import React, { useState, useEffect } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, CircularProgress, Stack, Typography } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { getMonitoraggioByAdv } from '../../services/getMonitoraggioByAdv';
import { styled } from '@mui/material/styles';

const CustomAccordion = styled(Accordion)(({ theme }) => ({
  border: '4px solid red',
}));

const EvidenzaEsitoMonitoraggio = ({ listDatiMonitoraggio }) => {
  const [loading, setLoading] = useState(true);

  return (
    <CustomAccordion>
      <AccordionSummary expandIcon={<ArrowDropDownIcon />}>
        EVIDENZA ESITO MONITORAGGIO
      </AccordionSummary>
      <AccordionDetails>
        <Stack>
          {listDatiMonitoraggio.map((item, index) => (
            <div key={index}>
              <Typography variant="caption" sx={{ fontSize: '0.75rem' }}>
                {'DATA APERTURA'}: {new Date(item.dataApertura).toLocaleDateString()}
              </Typography>
              <div></div>
              <Typography variant="caption" sx={{ fontSize: '0.75rem' }}>
                {'INPUT INIZIALE'}
              </Typography>
              <ul style={{ marginLeft: '20px' }}>
                {item.inputInizialeList.map((input, idx) => (
                  <li key={idx}>{input}</li>
                ))}
              </ul>
            </div>
          ))}
        </Stack>
      </AccordionDetails>
    </CustomAccordion>
  );
};

export default EvidenzaEsitoMonitoraggio;
